import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class AnswerDisplayElement extends SurveyElement {
  @Expose({ name: 'answer_descriptive_value' })
  text!: string | null;
}
